import React, { useState } from 'react';
import { IDevice } from '../../interfaces';
import { uploadScreenList } from '../../utils/pricing';

const MODE_APPEND = 0;
const MODE_MINUS = 1;

export const ModalFileUpload = (props: {
    close: () => void;
    availableDevices: IDevice[];
    selectedDevices: number[];
    onSelectList: (screens: number[]) => void;
}) => {
    const [state, setState] = useState<{
        closing: boolean;
        selectMode: number;
        screenList: number[];
    }>({
        closing: false,
        selectMode: MODE_APPEND,
        screenList: []
    });

    const save = () => {
        if (state.selectMode === MODE_APPEND) {
            props.onSelectList([...new Set([...props.selectedDevices, ...state.screenList])]);
        } else if (state.selectMode === MODE_MINUS) {
            const s = new Set(props.selectedDevices);
            state.screenList.forEach((id) => s.delete(id));
            props.onSelectList([...s]);
        }
    };

    return (
        <div
            className={`modal-background${state.closing ? ' closing' : ''}`}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    setState({
                        ...state,
                        closing: true
                    });

                    setTimeout(props.close, 200);
                }
            }}
        >
            <div className="modal small center">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Variable</th>
                            <th>Valeur</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Ecrans disponibles</td>
                            <td>{props.availableDevices.length}</td>
                        </tr>
                        <tr>
                            <td>Ecrans sélectionnés</td>
                            <td>{props.selectedDevices.length}</td>
                        </tr>
                        <tr>
                            <td>Ecrans du fichier</td>
                            <td>{state.screenList.length}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="flex vcenter">
                    <button
                        style={{ width: 205 }}
                        className="btn"
                        onClick={async () => {
                            const screenList = await uploadScreenList(props.availableDevices);

                            if (screenList) setState((prevState) => ({ ...prevState, screenList }));
                        }}
                    >
                        Sélectionner fichier
                    </button>
                    <select
                        className="form-control mr-10"
                        value={state.selectMode}
                        onChange={(e) => {
                            const value = parseInt(e.target.value);
                            setState((prevState) => ({ ...prevState, selectMode: value }));
                        }}
                    >
                        <option value={MODE_APPEND.toString()}>Ajouter à la selection actuelle</option>
                        <option value={MODE_MINUS.toString()}>Retirer de la selection actuelle</option>
                    </select>
                    <button
                        onClick={save}
                        disabled={state.screenList.length === 0}
                        style={{ width: 125 }}
                        className="btn"
                    >
                        Enregistrer
                    </button>
                </div>
            </div>
        </div>
    );
};
